// extracted by mini-css-extract-plugin
export default {"cautionBox":"x9-z"};